export default {"src":"/_next/static/media/ios.56cc50ef.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};